module.exports = __webpack_public_path__ + "media/images/vision/2-acbfb427f11f81d007062e372ee3f416.jpg";